import { parseCurrency } from '@helper/parseCurrency'

export const parsePurchaseAlertData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'alerta-comprar': item.alertaCompra ? 'ok' : 'no',
      'alerta-receber': item.receberAlerta ? 'ok' : 'no',
      'centro-id': item.lojaId,

      'produto-id': item.produtoId,

      'produto-material': item.produtoDescricao,
      'produto-categoria': item.categoriaId,
      'produto-subcategoria': item.subCategoriaDescricao,
      'produto-curva-abc': item.curvaABCDescricao,
      'produto-curva-abc-empresa': item.curvaABCEmpresaDescricao,

      'fornecedor-id': item.fornecedorId,
      'fornecedor-nome': item.fornecedorDescricao,

      'previsoes-vendamedia': parseCurrency({
        value: item.vendasMediasDiarias,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'previsoes-estoqueminimo': parseCurrency({
        value: item.estoqueMinimo,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'previsoes-utilizar-estoqueminimo': 'Sim',
      'previsoes-estoqueminimolt': parseCurrency({
        value: item.quantidadePrevista,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-atual': parseCurrency({
        value: item.disponivelReservado,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-transito': parseCurrency({
        value: item.ordenado,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-coberturaatual': parseCurrency({
        value: item.coberturaDias,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'fornecedor-leadtime': parseCurrency({
        value: item.tempoDeEspera,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-dep16': parseCurrency({
        value: item.estoqueOnDep16 || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-alvo': parseCurrency({
        value: item.estoqueAlvo || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-alvoDias': parseCurrency({
        value: item.pcT_DOSFrequencia || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      })
    })
  }

  return res
}
